import { Component } from 'react'
import { observer, inject } from 'mobx-react'
import dayjs from 'dayjs'

import { numberToDollars } from '../../../utils'
import { stateKeyToValue } from '../../../constants/us-states'
import ProfileCard from '../ProfileCard'
import ProfileField from '../ProfileField'
import { FieldGroup } from '../ProfileStyle'
import _ from 'lodash'

class AboutYouCard extends Component {
  genderValue(gender) {
    if (gender === 'M') {
      return 'Male'
    }
    if (gender === 'F') {
      return 'Female'
    }
    if (gender !== 'M' && gender !== 'F') {
      return ''
    }
  }

  maritalStatusValue() {
    const { person } = this.props.store
    if (person.maritalStatus === false) {
      return 'Single'
    }
    if (person.maritalStatus === true) {
      return 'Married'
    }
  }

  render() {
    const { features, person, account, primaryRetirementStatus, hasPlanAccess } = this.props.store

    const nameFields = (
      <FieldGroup>
        <ProfileField label='Your first name' value={person.firstName} />
        {features.enablePreferredName && (
          <ProfileField label='Your preferred name' value={person.displayName} />
        )}
        <ProfileField label='Your last name' value={person.lastName} />
      </FieldGroup>
    )

    if (!hasPlanAccess) {
      return (
        <ProfileCard title='About you'>
          {nameFields}
          {person.birthDate && (
            <FieldGroup>
              <ProfileField
                label='Your date of birth'
                value={dayjs(person.birthDate).format('MM/DD/YYYY')}
              />
            </FieldGroup>
          )}
        </ProfileCard>
      )
    }

    // PTD+ gives the retirement fields their own group; everywhere else they
    // continue the compensation group.
    const retirementFields = (
      <>
        <ProfileField label='Your retirement age' value={person.retirementAge} />
        {_.get(this, 'props.store.account.productId', '') !== 5 && (
          <ProfileField
            label='Plan to work part-time after retiring?'
            value={primaryRetirementStatus.planningWorkPartTime ? 'Yes' : 'No'}
          />
        )}
        {primaryRetirementStatus.planningWorkPartTime === 1 && (
          <>
            <ProfileField
              label='Duration: starting age?'
              value={primaryRetirementStatus.durationStartingAge}
            />
            <ProfileField
              label='Duration: stopping age?'
              value={primaryRetirementStatus.durationStoppingAge}
            />
            <ProfileField
              label='Annual income from in-retirement job'
              value={`$${numberToDollars(primaryRetirementStatus.annualIncome, true)}`}
            />
          </>
        )}
      </>
    )

    return (
      <ProfileCard title='About you' handleEdit={this.props.showAboutYou}>
        {nameFields}

        <FieldGroup>
          <ProfileField label='Your gender' value={this.genderValue(person.gender)} />
          <ProfileField
            label='Your date of birth'
            value={person.birthDate ? dayjs(person.birthDate).format('MM/DD/YYYY') : ''}
          />
        </FieldGroup>

        <FieldGroup>
          <ProfileField
            label='Your annual compensation before taxes'
            value={`$${numberToDollars(account.annualSalary, true)}`}
          />
          {features.enableOtherIncome && (
            <ProfileField
              label='Your other earned income, annually'
              value={`$${numberToDollars(person.otherIncome, true)}`}
            />
          )}
          {!features.enableSSI && retirementFields}
        </FieldGroup>

        {features.enableSSI && <FieldGroup>{retirementFields}</FieldGroup>}

        {(features.enableTaxStateChange || !features.enableSpouse) && (
          <FieldGroup>
            {features.enableTaxStateChange && (
              <ProfileField
                label='State in which file taxes'
                value={stateKeyToValue[account.taxState]}
              />
            )}
            {/* Only display Marital status in the About you section when Spouse isn't an enabled feature */}
            {!features.enableSpouse && (
              <ProfileField label='Marital status' value={this.maritalStatusValue()} />
            )}
          </FieldGroup>
        )}
      </ProfileCard>
    )
  }
}

export default inject('store')(observer(AboutYouCard))
